import React from 'react';
import { KuposErrorSuccessModal } from '../../../../common';

function SuccessModal(props) {
  return (
    <KuposErrorSuccessModal
      showModal={props.showModal}
      onHide={() => {
        props.setShowModal(false);
        props.setTransferStatus(false);
      }}
      onButtonClick={() => {
        props.setShowModal(false);
        props.setTransferStatus(false);
        props.setSelectedView('map');
        props.setRechargeAmount(null);
      }}
      success={props.transferStatus}
      title="PROFILE.ALMOST_READY"
      subTitle="PROFILE.GO_TO_NEAREST_REC_POINT"
    />
  );
}

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/components/SuccessModal.js